import { AlignTypes } from "@monorepo-web/components-library";
export const getLayouts = () => ({
    'default': [
        {
            id: 'data',
            label: 'Data',
            freeze: true,
            align: AlignTypes.left,
        },
        {
            id: 'tipo',
            label: 'Tipo',
            align: AlignTypes.left,
        },
        {
            id: 'desc',
            label: 'Descrição',
            align: AlignTypes.left,
        },
        {
            id: 'op',
            label: 'Operação',
            align: AlignTypes.left,
        },
        {
            id: 'quant',
            label: 'Quantidade',
            align: AlignTypes.right,
        },
        {
            id: 'valBruto',
            label: 'Valor Bruto',
            align: AlignTypes.right,
        },
        {
            id: 'valLiquido',
            label: 'Valor Líquido',
            align: AlignTypes.right,
        },
    ],
    'fluxo_caixa': [
        {
            id: 'data',
            label: 'Data',
            freeze: true,
            align: AlignTypes.left,
        },
        {
            id: 'op',
            label: 'Operação',
            align: AlignTypes.left,
        },
        {
            id: 'ativo',
            label: 'Ativo',
            align: AlignTypes.left,
        },
        {
            id: 'quant',
            label: 'Quantidade',
            align: AlignTypes.right,
        },
        {
            id: 'preco',
            label: 'Preço do Ativo',
            align: AlignTypes.right,
        },
        {
            id: 'valor',
            label: 'Valor Bruto',
            align: AlignTypes.right,
        },
        {
            id: 'saldo',
            label: 'Saldo Bruto',
            align: AlignTypes.right,
        }
    ]
});
